import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, Input, Typography } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import propTypes from 'prop-types';

const ConfirmModal = ({
  open,
  onClose,
  title,
  content,
  onConfirm,
  showMemo,
  isMemoRequired,
}) => {
  const { t } = useTranslation();
  const [memo, setMemo] = React.useState('');
  const [memoValidationError, setMemoValidationError] = React.useState(false);
  const { Title } = Typography;

  React.useEffect(() => {
    setMemo('');
    setMemoValidationError(false);
  }, [open]);

  const handleConfirmAction = () => {
    if (isMemoRequired && !memo) {
      setMemoValidationError(true);
      return;
    }
    onClose();
    if (showMemo) {
      onConfirm(memo);
    } else {
      onConfirm();
    }
  };

  return (
    <Modal
      key={open ? 'open' : 'closed'} 
      open={open}
      onCancel={onClose}
      title={<Title style={{ margin: 0 }} level={3}>{title}</Title>}
      footer={[
        <Button
          key="cancel"
          color="danger"
          variant="solid"
          icon={<CloseOutlined />}
          onClick={onClose}>
          {t('cancel')}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleConfirmAction}>
          {t('confirm')}
        </Button>,
      ]}  >

      <Title level={5}>{content}</Title>
      
      {showMemo && (
        <Form style={{ marginTop: '1rem' }} layout="vertical">
          <Form.Item
            label={t('memo')}
          >
            <Input.TextArea
              placeholder={t('memo')}
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
            />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default React.memo(ConfirmModal);


ConfirmModal.defaultProps = {
  open: false,
  onClose: () => null,
  title: '',
  content: '',
  onConfirm: () => null,
  showMemo: false,
  isMemoRequired: false,
}

ConfirmModal.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
  title: propTypes.string,
  content: propTypes.string,
  onConfirm: propTypes.func,
  showMemo: propTypes.bool,
  isMemoRequired: propTypes.bool
}
